module.exports = __webpack_public_path__ + "static/review-logo.2a93f1bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/review-logo.svg
// module id = 1099
// module chunks = 35783957827783